<component v-if="shouldRenderConfig" v-bind:is="getContainerType" v-bind:class="getClassName">
    <appPageOption
        v-for="(pageOption,key,index) in getActiveProductPageOptions"
        v-bind:key="getSelector + ' ' + index"
        v-bind:code="key"
        v-bind:index="index"
        v-bind:propsData="pageOption"
    ></appPageOption>
</component>